/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/priceCalculator.scss';

import React, {useState} from 'react';
import {BolmateButton, BolmateNumberInput} from "../controls";
import {navigate, parseMoney} from "@dvrd/dvr-controls";
import Image from "../misc/image";

type Bucket = { usage: number; price: number; }
const buckets: Bucket[] = [
    {usage: 100, price: 9},
    {usage: 1000, price: 19},
    {usage: 5000, price: 29},
], maxBucketUsage = buckets[buckets.length - 1].usage, overflowPrice = 49;

export default function PriceCalculator() {
    const [invoices, onChangeInvoices] = useState(0),
        [price, onChangePrice] = useState(9),
        onChangeInput = (value: string) => {
            onChangeInvoices(Number(value));
        },
        onCalculate = () => {
            let calcPrice = 0;
            if (invoices > maxBucketUsage) calcPrice = overflowPrice;
            for (const bucket of buckets) {
                if (invoices <= bucket.usage) {
                    calcPrice = bucket.price;
                    break;
                }
            }
            onChangePrice(calcPrice);
        },
        onRegister = () => {
            navigate('/registreren');
        }
    return (
        <div className='price-calculator'>
            <Image name='logo' className='logo'/>
            <div className='row'>
                <BolmateNumberInput onChange={onChangeInput} value={invoices} label='Aantal orders per maand'
                                    className='invoices' onEnter={onCalculate}/>
                <BolmateButton onClick={onCalculate} label='Berekenen' className='calc-btn'/>
            </div>
            <div className='row'>
                <label className='price-label'>Prijs per maand</label>
                <label className='price'>&euro;{parseMoney(price)}</label>
            </div>
            <div className='footer'>
                <BolmateButton onClick={onRegister} label='Nu Gratis Proberen'/>
                <label className='disclaimer'>30 dagen. Stopt automatisch.</label>
            </div>
        </div>
    )
}